import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-stone-500" data-testid="auth-loading">
                <div className="font-serif italic text-2xl">Cadence</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/auth" replace />;
    // Force fresh users through onboarding before they see the app
    if (!user.onboarded && location.pathname !== "/onboarding") {
        return <Navigate to="/onboarding" replace />;
    }
    return children;
}
